/* eslint-disable */
export const user = {
    id: 'cfaad35d-07a3-4447-a6c3-d8c3d54fd5df',
    name: 'Susana Nieblas',
    email: 'susananieblas@repobox.com',
    avatar: 'images/avatars/female-15.jpg',
    status: 'online',
};
